import { put, call } from 'redux-saga/effects';
import { addNewBookingRequest, getTenantBookingTypes } from '../service/bookingService';
import { sendCustomerSuccess, loadCustomerListError } from '../../store/action/customerAction';
import common from '../common';

function* getDefaultBookingType(tenantId) {
  try {
    const response = yield call(getTenantBookingTypes, tenantId)
    const list = Array.isArray(response.data.result.result)
      ? response.data.result.result
      : (response.data && response.data.result && Array.isArray(response.data.result.result) ? response.data.result.result : [])
    if (list.length === 0) return { bookingTypeId: null, estimatedEffort: null }
    const defaultType = list.find(t => t.isDefaultService) || list[0]
    return { bookingTypeId: defaultType.id, estimatedEffort: defaultType.estimatedEffort }
  } catch {
    return { bookingTypeId: null, estimatedEffort: null }
  }
}

export function* sendAddNewBookingRequest(data) {
  try {
    const { bookingTypeId, estimatedEffort } = yield* getDefaultBookingType(data.payload.TenantGuid)
    const bookingPayload = {
      ...data.payload,
      BookingTypes: bookingTypeId != null ? [bookingTypeId] : [],
      EstimatedEffort: estimatedEffort,
      Channel: '04'
    }
    const response = yield call(addNewBookingRequest, bookingPayload)
    if (response && response.data && response.data.statusCode && response.data.statusCode === 201) {
      yield put(sendCustomerSuccess(response.data.message))
    } else {
      yield put(loadCustomerListError(response.data.message))
    }
  } catch (error) {
    const massage = !error.response ? common.connectionError : common.error
    yield put(loadCustomerListError(massage))
  }
}
